import React from "react";
import { useForm } from "react-hook-form";
import { fetchWithAuth } from "../../utils/fetchWithAuth";
import Button from "../UI/Button";


const StepDataForm = ({orderId, phaseIndex, stepIndex, onUpdate, assignee}) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: {
            actualQuantity: assignee?.actualQuantity || "",
            defectQuantity: assignee?.defectQuantity || 0,
        },
    });

    const onSubmit = async (data) => {
        try {
            const endpoint = assignee?.status === "done" ? "update-step" : "complete-step";

            await fetchWithAuth(
                `${process.env.REACT_APP_API_URL}/orders/${orderId}/${endpoint}`,
                {
                    method: "POST",
                    body: JSON.stringify({
                        phaseIndex,
                        stepIndex,
                        userId: assignee.userId,
						date: assignee.date, 
						shiftSchedule: assignee.shiftSchedule, 
                        actualQuantity: Number(data.actualQuantity),
                        defectQuantity: Number(data.defectQuantity),
                    }),
                }
            );
            onUpdate();
        } catch (error) {
            console.error("Failed to update step data:", error);
        }
    };

    const handleRevert = async () => {
        try {
            await fetchWithAuth(
                `${process.env.REACT_APP_API_URL}/orders/${orderId}/revert-step`,
                {
                    method: "POST",
                    body: JSON.stringify({ 
                        phaseIndex, 
                        stepIndex,
                        userId: assignee.userId 
                    }),
                }
            );
            onUpdate();
        } catch (error) {
            console.error("Failed to revert step status:", error);
        }
    };

    return (
        <div className="border rounded p-2 bg-[#1E1E1E] border-[#3E3E42]">
            <div className="grid grid-cols-3 gap-2 mb-2">
                <div className="space-y-1">
                    <label className="block text-sm font-medium text-gray-400">
                        План
                    </label>
                    <div className="p-2 rounded bg-[#2D2D30] border border-[#3E3E42] text-white">
                        {assignee?.quantity || 0}
                    </div>
                </div>
                {assignee?.status === "done" && (
                    <>
                        <div className="space-y-1">
                            <label className="block text-sm font-medium text-gray-400">
                                Годная продукция
                            </label>
                            <div className="p-2 rounded bg-[#2D2D30] border border-[#3E3E42] text-white">
                                {assignee?.actualQuantity || 0}
                            </div>
                        </div>
                        <div className="space-y-1">
                            <label className="block text-sm font-medium text-gray-400">
                                Брак
                            </label>
                            <div className="p-2 rounded bg-[#2D2D30] border border-[#3E3E42] text-white">
                                {assignee?.defectQuantity || 0}
                            </div>
                        </div>
                    </>
                )}
            </div>
            {assignee?.status !== "done" ? (
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-2">
                    <div className="grid grid-cols-2 gap-2">
                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-400">
                                Фактическое выполнение (годной продукции)
                            </label>
                            <input
                                type="number"
                                {...register("actualQuantity", {
                                    required: "Укажите фактическое количество",
                                    min: {
                                        value: 0,
                                        message:
                                            "Количество не может быть отрицательным",
                                    },
                                })}
                                className="w-full p-2 rounded text-gray-400 bg-[#1E1E1E] border border-[#3E3E42] focus:outline-none focus:border-[#007ACC]"
                            />
                            {errors.actualQuantity && (
                                <span className="text-red-500 text-sm">
                                    {errors.actualQuantity.message}
                                </span>
                            )}
                        </div>
                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-400">
                                Брак
                            </label>
                            <input
                                type="number"
                                {...register("defectQuantity", {
                                    min: {
                                        value: 0,
                                        message:
                                            "Количество брака не может быть отрицательным",
                                    },
                                })}
                                className="w-full p-2 rounded text-gray-400 bg-[#1E1E1E] border border-[#3E3E42] focus:outline-none focus:border-[#007ACC]"
                            />
                            {errors.defectQuantity && (
                                <span className="text-red-500 text-sm">
                                    {errors.defectQuantity.message}
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="flex justify-end">
                        <Button type="submit" variant="primary">
                            Отметить выполнение
                        </Button>
                    </div>
                </form>
            ) : (
                <div className="flex justify-end space-x-2">
                    <Button onClick={handleRevert} variant="danger">
                        Вернуть в работу
                    </Button>
                </div>
            )}
        </div>
    );
};

export default StepDataForm;
